<template>
  <div class="big-screen" id="bigScreen">
    <div class="modify-wrap">
      <el-button type="danger" class="upLoad" size="small" @click="coverImg"
        ><input
          type="file"
          accept=".png,.jpg,.jpeg"
          @change="coverImg"
          class="pcImgFile"
          title="选择图片"
        />上传背景</el-button
      >
      <span class="txt-color">填写或选择机位占用颜色:
        <!--  -->
        <el-input placeholder="机位颜色值..." style="width:80px" v-model="form.computerFillColor"/>
        <!--  -->
        <el-color-picker v-model="form.computerFillColor" @change="changeComputerColor"></el-color-picker>
      </span>
      <span class="txt-color">填写或选择字体颜色:
        <el-input placeholder="字体颜色值..." style="width:80px" v-model="form.computerTextColor"/>
        <el-color-picker v-model="form.computerTextColor" @change="changeComputerTextColor"></el-color-picker></span>
      <!-- <div class="type size">
        <span class="tit" style="margin-left: 20px">机位样式：</span>
        <el-select
          size="small"
          style="width: 140px; margin: 0 20px; margin-left: 0px"
          v-model="form.computerNodeType"
          @change="changeNodeType"
          placeholder="选择机位样式"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div> -->
      <div class="size" style="margin-left: 20px">
        <span class="tit">机位样式大小：</span>
        <el-slider
          style="min-width: 250px"
          :min="0"
          :max="500"
          show-input
          @change="changeComputerNodeSize"
          v-model="form.computerNodeSize"
        ></el-slider>
      </div>
      <el-button type="warning" size="small" @click.stop="doShowDrawer"
        >选择机位</el-button
      >

      <el-button
        type="primary"
        size="small"
        @click="copy"
        style="margin-left: 20px"
        >复制大屏链接</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="openBigScreen"
        style="margin-left: 20px"
        >查看大屏</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="openBigScreenForAd"
        style="margin-left: 20px;opacity:0;"
        >大屏</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="save"
        style="margin-left: 50px"
        >保存</el-button
      >
      <div id="copyData" style="width: 0; height: 0; font-size: 0; opacity: 0">
        {{ bigScreenUrl }}
      </div>
      <div class="tip" v-if="!noData">
        双击机位图标可进行旋转和键盘细微移动，右键可进行删除
      </div>
      <div class="tip" v-if="noData">暂未上传任何机位大屏信息</div>
    </div>
    <div class="out-wrap" :style="showDrawer?'padding-right:450px':''">
      <div class="canvas-wrap" @click.stop="" id="canvasWrap"></div>
      <div class="context-menu" @click.stop="">
        <div class="del" @click.stop="delNode">删除</div>
      </div>
      <div class="context-menu-extra" @click.stop="">
        <div class="del" @click.stop="addExtra('text')">插入文本</div>
        <div class="del" style="border-top: 1px solid #ddd">
          <input
            type="file"
            accept=".png,.jpg,.jpeg"
            @change="upImage"
            class="upImage"
            title="选择图片"
          />
          插入图片
        </div>
      </div>
      <!-- <div v-if="noData" class="nodata-tip">暂未上传任何机位大屏信息</div> -->
    </div>

    <!--  -->
    <div class="drawer-wrap" v-if="showDrawer" @click.stop="">
      <div class="inner-wrap">
        <div class="tit">
          <span>选择机位</span>
          <span class="close" @click.stop="showDrawer = false">关闭</span>
        </div>
        <div class="drawer-cont">
          <el-collapse v-model="activeNames">
            <el-collapse-item
              v-for="(it, ind) in sites"
              :key="ind"
              :title="`${it.name}`"
              :name="`${it.id}`"
            >
              <div
                class="site-img"
                v-for="(ite, inde) in it.nums"
                :key="`c_${inde}`"
              >
                <!-- <span draggable="true"> -->
                <img
                  draggable="true"
                  :src="`/static/bigScreen/assets/computer_free.png`"
                  :data-ipAddress="`${ite.ipAddress}`"
                  :data-ipNo="`${computedIpNo(ite.ipAddress)}`"
                  :data-fillName="`${computedIpNo(ite.name)}`"
                  alt=""
                />
                <!-- <span class="ip-no">{{ computedIpNo(ite.ipAddress) }}</span> -->
                <!-- </span> -->
                <div class="ip">{{ ite.ipAddress }}</div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
    <!--  -->
    <!-- <el-dialog
      title="添加内容"
      :visible.sync="showExtra"
      custom-class="extra"
      :modal-append-to-body="true"
      :append-to-body="true"
      class="dialog"
    >
      <template v-if="extraType == 'text'">
        <div class="cont-item">
          <div class="tip">请输入文本内容：</div>
          <el-input
            v-model="textVal"
            type="textarea"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div class="cont-item">
          <div class="tip">请选择字体颜色：</div>
          <el-color-picker v-model="textColor"></el-color-picker>
        </div>
        <div class="cont-item">
          <div class="tip">字体效果：</div>
          <div :style="`color:${textColor};font-size:30px;`">{{ textVal }}</div>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showExtra = false">取 消</el-button>
        <el-button type="primary" @click="doAddExtra">创 建</el-button>
      </span>
    </el-dialog> -->
    <!--  -->
    <div class="my-dialog" v-if="showExtra" @click.stop="showExtra=false;">
      <div class="inner-dialog" @click.stop="">
        <template v-if="extraType == 'text'">
          <div class="cont-item">
            <div class="tip">请输入文本内容：</div>
            <el-input
              v-model="textVal"
              type="textarea"
              placeholder="请输入内容"
            ></el-input>
          </div>
          <div class="cont-item">
            <div class="tip">请选择字体颜色：</div>
            <el-color-picker v-model="textColor"></el-color-picker>
          </div>
          <div class="cont-item">
            <div class="tip">字体效果：</div>
            <div :style="`color:${textColor};font-size:30px;`">
              {{ textVal }}
            </div>
          </div>
        </template>
        <div class="btns">
          <el-button @click="showExtra = false">取 消</el-button>
          <el-button type="primary" @click="doAddExtra">创 建</el-button>
        </div>
      </div>
    </div>
    <!--  -->
  </div>
</template>
<script>
import { API_BASE_URL } from "./../../urlConfig/index";
export default {
  name: "bigScreen",
  props: ["curStoreId"],
  data() {
    return {
      textVal: "",
      textColor: "#000",
      //
      showExtra: false,
      canCreate: true,
      noData: true,
      coverImgMaxSize: 15 * 1024 * 1024, // 图片最大字节数
      sites: [],
      activeNames: ["1"],
      showDrawer: false,
      form: {
        background: "",
        computerNodeType: "text",
        computerNodeSize: 70,
        canvasJsonText: "",
        computerFillColor:"#e66a6a",
        computerTextColor:"#fff",
        extra: [],
      },
      options: [
        {
          label: "文本式",
          value: "text",
        },
        {
          label: "电脑图标式",
          value: "computer",
        },
      ],
      computerObj: {
        ip: "192.168.0.1",
        status: "free",
        name: "001",
        offset: {
          x: 0,
          y: 0,
          rotation: 0,
          skewX: 0,
          skewY: 0,
        },
      },
      textObj: {
        type: "text",
        uuidName: "",
        fontSize: 30,
        content: "",
        fill: "",
        offset: {
          x: 0,
          y: 0,
          rotation: 0,
          skewX: 0,
          skewY: 0,
          scaleX: 1,
          scaleY: 1,
        },
      },
      imageObj: {
        type: "image",
        uuidName: "",
        path: "",
        offset: {
          x: 0,
          y: 0,
          width: 200,
          height: 200,
          rotation: 0,
          skewX: 0,
          skewY: 0,
          scaleX: 1,
          scaleY: 1,
        },
      },
      stageWidth: "",
      stageHeight: "",
      stage: null,
      layer: null,
      computerLayer: null,
      contextMenuNode: null,
      rollComputer: null,
      container: null,
      nowSelGroup: null,
      delta: 0.5,
      computers: [],
      bigScreenUrl: "",
      rollExtra: null,
      extraType: "text",
      siteNamesObj:{},
      bigScreenUrlForAd:""
    };
  },
  watch: {
    showExtra(val) {
      if (!val) {
        this.textVal = "";
      }
    },
  },
  methods: {
    changeComputerColor(){
      console.log("lll",this.form.computerFillColor);
      setTimeout(() => {
        this.createStage();
      }, 50);
    },
    changeComputerTextColor(){
      console.log("lll",this.form.computerTextColor);
      setTimeout(() => {
        this.createStage();
      }, 50);
    },
    // 
    doAddExtra() {
      this.showExtra = false;
      if (!String(this.textVal).trim()) {
        return;
      }
      if (this.extraType == "text") {
        this.$set(this.textObj, "content", this.textVal);
        this.$set(this.textObj, "fill", this.textColor);
        this.createExtra(this.extraType, this.textObj, true);
      }
    },
    addExtra(type) {
      this.showExtra = true;
      $(".context-menu-extra").css({
        display: "none",
      });
      $(".context-menu").css({
        display: "none",
      });
      this.extraType = type;
    },
    //
    openBigScreen() {
      window.open(this.bigScreenUrl, "_blank");
    },
    openBigScreenForAd(){
      window.open(this.bigScreenUrlForAd, "_blank");
    },
    copy() {
      const range = document.createRange();
      range.selectNode(document.getElementById("copyData"));
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        selection.removeAllRanges();
      }
      selection.addRange(range);
      document.execCommand("copy");
      this.$message({
        customClass: "success",
        message: "复制成功",
      });
      selection.removeAllRanges();
    },
    save() {
      if (!this.computerLayer || !this.form.background) {
        return;
      }
      console.log("this.computerLayer.getChildren", this.computers);
      let tempComputers = [];
      this.computerLayer.getChildren(node=>{
        console.log("node",node)
        if (node.getClassName() == "Group") {
          let ipArr = node.attrs.name.split(".");
          tempComputers.push({
            ip:node.attrs.name,
            name:this.siteNamesObj[node.attrs.name],
            // name:ipArr[ipArr.length - 1],
            offset:{
              x: node.attrs.x > 1920 ? 1910 : node.attrs.x,
              y: node.attrs.y > 1080 ? 1070 : node.attrs.y,
              rotation: node.attrs.rotation,
              skewX: node.attrs.skewX,
              skewY: node.attrs.skewY,
            },
            status:"free"
          })
        }
      });
      console.log("tempComputers",tempComputers)
      // this.computerLayer.getChildren((node) => {
      //   if (node.getClassName() == "Group") {
      //     this.computers.forEach((it) => {
      //       console.log("node.attrs.name",node.attrs.name);
      //       if (node.attrs.name == it.ip) {
      //         it.offset = {
      //           x: node.attrs.x,
      //           y: node.attrs.y,
      //           rotation: node.attrs.rotation,
      //           skewX: node.attrs.skewX,
      //           skewY: node.attrs.skewY,
      //         };
      //       }
      //     });
      //   }
      // });
      const form = JSON.parse(JSON.stringify(this.form));
      let extra = [];
      if (form.hasOwnProperty("extra") && Array.isArray(form.extra)) {
        extra = form.extra;
      }
      this.extraDrawLayer.getChildren((node) => {
        console.log(node);
        if (
          node.textArr &&
          Array.isArray(node.textArr) &&
          node.textArr.length
        ) {
          let textObj = {
            type: "text",
            uuidName: node.attrs.uuidName,
            fontSize: 30,
            content: node.attrs.text,
            fill: node.attrs.fill,
            offset: {
              x: node.attrs.x > 1920 ? 1910 : node.attrs.x,
              y: node.attrs.y > 1080 ? 1070 : node.attrs.y,
              rotation: node.attrs.rotation,
              skewX: node.attrs.skewX,
              skewY: node.attrs.skewY,
              scaleX: node.attrs.scaleX,
              scaleY: node.attrs.scaleY,
            },
          };
          extra.push(textObj);
        }
      });
      this.extraDrawLayerForImage.getChildren((node) => {
        console.log(node.getClassName());
        if (node.attrs.hasOwnProperty("image")) {
          let imageObj = {
            type: "image",
            uuidName: node.attrs.uuidName,
            path: node.attrs.path,
            offset: {
              x: node.attrs.x > 1920 ? 1910 : node.attrs.x,
              y: node.attrs.y > 1080 ? 1070 : node.attrs.y,
              width: node.attrs.width,
              height: node.attrs.height,
              rotation: node.attrs.rotation,
              skewX: node.attrs.skewX,
              skewY: node.attrs.skewY,
              scaleX: node.attrs.scaleX,
              scaleY: node.attrs.scaleY,
            },
          };
          extra.push(imageObj);
        }
      });
      if (extra && Array.isArray(extra)) {
        extra = extra.filter((it) => {
          if (!it.hasOwnProperty("uuidName")) {
            return false;
          }
          return true;
        });
        let extraObj = {};
        extra.forEach((it) => {
          extraObj[it.uuidName] = it;
        });
        let tempExtra = [];
        for (let k in extraObj) {
          tempExtra.push(extraObj[k]);
        }
        extra = tempExtra;
      }
      let finalComputerArr = [];
      let obj = {};
      if (Array.isArray(tempComputers)) {
        try {
          tempComputers.forEach((it) => {
            console.log("it",it)
            obj[it.ip] = it;
          });
        } catch (error) {}
        for (let k in obj) {
          finalComputerArr.push(obj[k]);
        }
      }
      // 
      // console.log("finalComputerArr",finalComputerArr)
      // finalComputerArr.forEach(it=>{
      //   console.log("it",it)
      //   it.ip = this.replaceIPPrefix(it.ip, '192.168.0','192.168.68');
      // })
      // console.log("finalComputerArr end",finalComputerArr)
      // return;
      // 
      setTimeout(() => {
        const jsonText = {
          ...this.form,
          extra,
          // canvasJsonText: this.computers,
          canvasJsonText: finalComputerArr,
        };
        console.log("jsonText", jsonText);
        this.$http({
          url: "map/update",
          method: "POST",
          data: {
            storeId: this.curStoreId,
            h5JsonText: JSON.stringify(jsonText),
          },
        }).then((res) => {
          this.$message({ customClass: "success", message: "保存成功" });
        });
      }, 100);
    },
    replaceIPPrefix(str, from, to) {
      // return str.replace(new RegExp(from, 'g'), to);
    },
    changeComputerNodeSize(e) {
      console.log(e);
      this.form.computerNodeSize = e;
      setTimeout(() => {
        this.createStage();
      }, 50);
    },
    changeNodeType(e) {
      console.log(e);
      setTimeout(() => {
        this.createStage();
      }, 50);
    },
    createExtra(type, obj, init = false) {
      if (type == "text") {
        const text = new Konva.Text({
          uuidName: obj.uuidName ? obj.uuidName : this.$uuid.create(1).hex,
          x: obj.offset.x,
          y: obj.offset.y,
          rotation: obj.offset.rotation,
          skewX: obj.offset.skewX,
          skewY: obj.offset.skewY,
          scaleX: obj.offset.scaleX,
          scaleY: obj.offset.scaleY,
          text: obj.content,
          fontSize: obj.fontSize,
          fill: obj.fill,
          draggable: true,
        });
        text.on("dblclick", (e) => {
          if (e.evt.button === 2) {
            return;
          }
          this.rollExtra = new Konva.Transformer({
            nodes: [e.currentTarget],
            centeredScaling: true,
            rotationSnaps: [0, 90, 180, 270],
            resizeEnabled: true,
          });

          // this.rollExtra.anchorStyleFunc((anchor) => {
          //   anchor.fill("#00ff00");
          //   anchor.attrs.stroke = "rgb(247,186,42)";
          //   if (anchor.attrs.name == "rotater _anchor") {
          //     anchor.fill(undefined);
          //     anchor.attrs.offsetX = 12;
          //     anchor.attrs.offsetY = 24;
          //     anchor.attrs.width = 25;
          //     anchor.attrs.height = 25;
          //     const anchorGroup = anchor.getParent();
          //     console.log("anchorGroup",anchorGroup);
          //     this.anchor.attrs.x = anchorGroup.width() / 2;
          //     this.anchor.attrs.y = -75;
          //     anchorGroup.add(this.anchor);
          //   }
          //   anchor.cornerRadius(anchor.width() / 2);
          // });

          this.extraDrawLayer.add(this.rollExtra);
        });
        text.on("click", (e) => {
          if (e.evt.button === 2) {
            console.log(this.stage.getPointerPosition());
            console.log(e.currentTarget);
            this.contextMenuNode = e.currentTarget;

            $(".context-menu").css({
              display: "block",
              top: this.stage.getPointerPosition().y + 10 + "px",
              left: this.stage.getPointerPosition().x + 10 + "px",
            });
            setTimeout(() => {
              $(".context-menu-extra").css({
                display: "none",
              });
            }, 50);
          }
        });
        this.extraDrawLayer.add(text);
        if (init) {
          this.rollExtra = new Konva.Transformer({
            nodes: [text],
            centeredScaling: true,
            rotateAnchorOffset: 30,
            rotationSnaps: [0, 90, 180, 270],
            resizeEnabled: true,
          });
          this.extraDrawLayer.add(this.rollExtra);
        }
      } else if (type == "image") {
        Konva.Image.fromURL(obj.path, (darthNode) => {
          darthNode.setAttrs({
            uuidName: obj.uuidName ? obj.uuidName : this.$uuid.create(1).hex,
            path: obj.path,
            x: obj.offset.x,
            y: obj.offset.y,
            width: obj.offset.width,
            height: obj.offset.height,
            rotation: obj.offset.rotation,
            skewX: obj.offset.skewX,
            skewY: obj.offset.skewY,
            scaleX: obj.offset.scaleX,
            scaleY: obj.offset.scaleY,
            keepRatio: true,
            draggable: true,
          });
          console.log(darthNode);
          darthNode.on("dblclick", (e) => {
            if (e.evt.button === 2) {
              return;
            }
            this.rollExtra = new Konva.Transformer({
              nodes: [e.currentTarget],
              centeredScaling: true,
              rotationSnaps: [0, 90, 180, 270],
              resizeEnabled: true,
            });
            this.extraDrawLayerForImage.add(this.rollExtra);
          });
          darthNode.on("click", (e) => {
            if (e.evt.button === 2) {
              console.log(this.stage.getPointerPosition());
              console.log(e.currentTarget);
              this.contextMenuNode = e.currentTarget;

              $(".context-menu").css({
                display: "block",
                top: this.stage.getPointerPosition().y + 10 + "px",
                left: this.stage.getPointerPosition().x + 10 + "px",
              });
              setTimeout(() => {
                $(".context-menu-extra").css({
                  display: "none",
                });
              }, 50);
            }
          });
          this.extraDrawLayerForImage.add(darthNode);
          if (init) {
            this.rollExtra = new Konva.Transformer({
              nodes: [darthNode],
              centeredScaling: true,
              rotationSnaps: [0, 90, 180, 270],
              resizeEnabled: true,
            });
            this.extraDrawLayerForImage.add(this.rollExtra);
          }
        });
      }
    },
    createStage(time) {
      if (!this.canCreate) {
        return;
      }
      this.canCreate = false;
      const bigScreenEle = document.querySelector("#canvasWrap");
      this.stageWidth = bigScreenEle.clientWidth;
      console.log("stageWidth", this.stageWidth);
      this.stageHeight = bigScreenEle.clientHeight;
      this.stage = new Konva.Stage({
        container: "canvasWrap",
        width: this.stageWidth,
        height: this.stageHeight,
      });
      this.layer = new Konva.Layer();
      this.computerLayer = new Konva.Layer();
      this.extraDrawLayer = new Konva.Layer();
      this.extraDrawLayerForImage = new Konva.Layer();
      this.stage.add(this.layer);
      this.stage.add(this.computerLayer);
      this.stage.add(this.extraDrawLayerForImage);
      this.stage.add(this.extraDrawLayer);
      this.stage.on("contextmenu", (e) => {
        e.evt.preventDefault();
      });
      //
      //
      Konva.Image.fromURL(this.form.background, (darthNode) => {
        darthNode.setAttrs({
          x: 0,
          y: 0,
          width: this.stage.width(),
          height: this.stage.height(),
          keepRatio: true,
        });
        this.computerLayer.add(darthNode);
        this.computerLayer.batchDraw();
        this.computerLayer.on("click", (event) => {
          event.cancelBubble = true;
          if (this.rollComputer) {
            this.rollComputer.stopTransform();
            this.rollComputer.hide();
          }
          if (this.rollExtra) {
            this.rollExtra.stopTransform();
            this.rollExtra.hide();
          }
        });
      });
      //
      this.container = this.stage.container();
      this.container.addEventListener("dragover", (e) => {
        e.preventDefault();
      });
      this.container.addEventListener("contextmenu", (e) => {
        console.log(e);
        e.stopPropagation();
        $(".context-menu-extra").css({
          display: "block",
          top: this.stage.getPointerPosition().y + 10 + "px",
          left: this.stage.getPointerPosition().x + 10 + "px",
        });
      });
      this.container.addEventListener("drop", (e) => {
        e.preventDefault();
        this.stage.setPointersPositions(e);
        let url = `/static/bigScreen/assets/computer_free.png`;
        if (this.form.computerNodeType == "text") {
          url = `/static/bigScreen/assets/computer_free_text.png`;
        }
        console.log(this.stage.getPointerPosition());
        const stagePointerPosition = this.stage.getPointerPosition();
        this.$set(this.computerObj.offset, "x", stagePointerPosition.x - 16);
        this.$set(this.computerObj.offset, "y", stagePointerPosition.y - 16);
        if (!this.computerObj.ip) {
          this.$message({ customClass: "error", message: "此机位已添加" });
          return;
        }
        let computers = JSON.parse(JSON.stringify(this.computers));
        if (computers && Array.isArray(computers)) {
          computers.push(this.computerObj);
        } else {
          computers = [];
          computers.push(this.computerObj);
        }
        
        let obj = {};
        console.log("computers",computers)
        if(computers && Array.isArray(computers)){
          computers.forEach(it=>{
            obj[it.ip] = it;
          })
        }
        console.log("obj",obj)
        let tempComputers = [];
        for (let k in obj) {
          tempComputers.push(obj[k]);
        }
        
        this.$set(this, "computers", tempComputers);
        // this.$set(this, "computers", computers);
        this.drawComputer(this.computerObj, url, true);
      });
      this.container.tabIndex = 1;
      this.container.focus();
      this.container.addEventListener("keydown", (e) => {
        console.log(this.nowSelGroup);
        if (e.keyCode === 37) {
          this.nowSelGroup.x(this.nowSelGroup.x() - this.delta);
        } else if (e.keyCode === 38) {
          this.nowSelGroup.y(this.nowSelGroup.y() - this.delta);
        } else if (e.keyCode === 39) {
          this.nowSelGroup.x(this.nowSelGroup.x() + this.delta);
        } else if (e.keyCode === 40) {
          this.nowSelGroup.y(this.nowSelGroup.y() + this.delta);
        } else {
          return;
        }
        e.preventDefault();
      });
      this.container.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        $(".context-menu").css({
          display: "none",
        });
        $(".context-menu-extra").css({
          display: "none",
        });
      });
      //
      this.anchor = new Konva.Path({
        x: 0,
        y: 0,
        width: 32,
        height: 32,
        data: "M148.361503 873.076215a33.27639 33.27639 0 0 1 0.204778-47.150084 33.583556 33.583556 0 0 1 47.354862 0.204778A444.316592 444.316592 0 0 0 511.944454 957.291078c104.436669 0 203.293143-35.938501 280.852728-99.317224l35.580139-32.81564a33.583556 33.583556 0 0 1 47.303668 1.791806 33.27639 33.27639 0 0 1-1.791806 47.09889l-37.064778 34.146695A511.176537 511.176537 0 0 1 511.944454 1023.99744a511.43251 511.43251 0 0 1-363.582951-150.921225z m863.49671-248.497838a33.481167 33.481167 0 0 1-65.426501-14.385639 443.139119 443.139119 0 0 0-299.129144-518.394954A33.327584 33.327584 0 1 1 667.575568 28.265477a509.58951 509.58951 0 0 1 344.180256 596.3129zM275.374922 138.640701a443.036731 443.036731 0 0 0-198.788032 467.456481 33.481167 33.481167 0 0 1-65.52889 13.771306A509.999065 509.999065 0 0 1 279.624061 59.596478C328.821923 31.439533 431.415591-4.191801 507.336954 0.620477c8.549472-1.689417 17.96925 0 25.597223 5.938555 6.4505 5.119445 9.982917 12.081889 11.109194 20.273001 0.255972 2.713306-0.409556 5.221833-1.023889 8.037528a22.832723 22.832723 0 0 1-7.781555 12.133083L341.262173 263.759926a28.208139 28.208139 0 0 1-29.999945 6.91125 30.204723 30.204723 0 0 1-20.836139-23.703028l-15.051167-108.378641z m-4.965861 785.322793c-2.969278-0.46075-7.269611 31.740556-34.402668 17.918056-48.225168-24.624528-138.225003-97.781391-174.93142-168.736892a31.331001 31.331001 0 0 1-8.037528-24.931695c1.023889-8.191111 5.221833-14.846389 11.62114-19.965834 2.201361-1.638222 4.658695-2.354944 7.423194-3.276444a22.832723 22.832723 0 0 1 14.385639 0.409555l285.7162 54.675668c10.392472 1.945389 18.839556 10.750834 21.399278 22.116a30.204723 30.204723 0 0 1-9.573361 30.102334l-113.651669 91.689252z m716.671041-436.688619c1.126278 2.815694 30.921445-10.085306 33.020417 20.273 3.737195 54.061334-12.542639 168.890475-54.522084 236.825504a31.331001 31.331001 0 0 1-17.201334 19.812251 29.999945 29.999945 0 0 1-23.139889 0.307167c-2.559722-1.023889-4.402722-2.815694-6.655278-4.709889a22.832723 22.832723 0 0 1-7.013639-12.54264l-100.341113-273.071171a28.208139 28.208139 0 0 1 7.986333-29.692779 30.204723 30.204723 0 0 1 30.716668-7.320805l137.149919 50.170556z",
        fill: "white",
        scaleX: 0.025,
        scaleY: 0.025,
      });
      let extra = [];
      if (this.form.hasOwnProperty("extra")) {
        const form = JSON.parse(JSON.stringify(this.form));
        extra = form.extra;
      }
      if (time) {
        setTimeout(() => {
          this.computers.forEach((it) => {
            let url = `/static/bigScreen/assets/computer_${it.status}.png`;

            if (this.form.computerNodeType == "text") {
              url = `/static/bigScreen/assets/computer_${it.status}_text.png`;
            }
            this.drawComputer(it, url);
          });
          //
          if (extra && Array.isArray(extra)) {
            extra.forEach((it) => {
              // if (it.type == "text") {
              this.createExtra(it.type, it);
              // }
            });
          }
          //
        }, time);
      } else {
        setTimeout(() => {
          this.computers.forEach((it) => {
            let url = `/static/bigScreen/assets/computer_${it.status}.png`;

            if (this.form.computerNodeType == "text") {
              url = `/static/bigScreen/assets/computer_${it.status}_text.png`;
            }
            this.drawComputer(it, url);
          });
          //
          if (extra && Array.isArray(extra)) {
            extra.forEach((it) => {
              // if (it.type == "text") {
              this.createExtra(it.type, it);
              // }
            });
          }
          //
        }, 599);
      }
      setTimeout(() => {
        this.canCreate = true;
      }, 1999);
    },
    drawComputer(it, url, isSel = false) {
      // 
      let multFlag = false;
      this.computerLayer.getChildren(node=>{
        if (node.getClassName() == "Group") {
          if(it.ip == node.attrs.name){
            multFlag = true;
          }
        }
      });
      if(multFlag){
        console.log("当前有重复的机位")
        return;
      }
      // 
      const _this = this;
      const group = new Konva.Group({
        width: 32,
        height: 32,
        draggable: true,
        keepRatio: true,
        x: (it.offset.x / 1920) * this.stageWidth,
        y: (it.offset.y / 1080) * this.stageHeight,
        rotation: it.offset.rotation,
        name: it.ip,
        scale: {
          x: this.form.computerNodeSize / 100,
          y: this.form.computerNodeSize / 100,
        },
        skewX: it.offset.skewX ? it.offset.skewX : 0,
        skewY: it.offset.skewY ? it.offset.skewY : 0,
      });

      Konva.Image.fromURL(url, (darthNode) => {
        darthNode.setAttrs({
          x: 0,
          y: 0,
          width: 32,
          height: 27, 
          fill: this.form.computerFillColor,
        });
        let simpleText = new Konva.Text({
          x: 16,
          y: 7,
          align: "center",
          text: it.name,
          fontSize: 16,
          // fontFamily: "Calibri",
          // fill: "#fff",
          fill: this.form.computerTextColor,
        });
        simpleText.offsetX(simpleText.width() / 2);

        group.add(darthNode);
        group.add(simpleText);
        this.computerLayer.batchDraw();
      });
      group.on("mouseover", function () {
        document.body.style.cursor = "pointer";
      });
      group.on("dragend", function (e) {
        const posObj = this.absolutePosition();
        it.offset.x = posObj.x;
        it.offset.y = posObj.y;
        document.body.style.cursor = "default";
      });
      group.on("dblclick", function (e) {
        if (e.evt.button === 2) {
          return;
        }
        _this.rollComputer = new Konva.Transformer({
          nodes: [e.currentTarget],
          centeredScaling: true,
          rotationSnaps: [0, 90, 180, 270],
          resizeEnabled: false,
        });
        //
        _this.rollComputer.borderEnabled(false);
        _this.rollComputer.anchorSize(25);
        _this.rollComputer.anchorStyleFunc((anchor) => {
          if (anchor.attrs.name == "rotater _anchor") {
            anchor.fill(undefined);
            _this.anchor.attrs.x = anchor.attrs.x - 12.5;
            _this.anchor.attrs.y = anchor.attrs.y + 12.5;

            const anchorGroup = anchor.getParent();
            anchorGroup.add(_this.anchor);
            console.log(anchorGroup);
            anchor.attrs.offsetY = -13.5;
            anchor.attrs.stroke = undefined;
            anchor.cornerRadius(anchor.width() / 2);
          }
        });
        //
        _this.rollComputer.on("transformend", function (te) {
          console.log(group);
        });
        _this.computerLayer.add(_this.rollComputer);
        _this.nowSelGroup = e.currentTarget;
      });
      group.on("click", (e) => {
        console.log(e);
        if (e.evt.button === 2) {
          console.log(this.stage.getPointerPosition());
          this.contextMenuNode = e.currentTarget;

          $(".context-menu").css({
            display: "block",
            top: this.stage.getPointerPosition().y + 10 + "px",
            left: this.stage.getPointerPosition().x + 10 + "px",
          });
          setTimeout(() => {
            $(".context-menu-extra").css({
              display: "none",
            });
          }, 50);
        }
      });
      if (isSel) {
        this.nowSelGroup = group;
      }
      this.computerLayer.add(group);
    },
    //
    delNode() {
      let tempNode = this.contextMenuNode.destroy();
      try {
        let computers = JSON.parse(JSON.stringify(this.computers));
        if (computers && Array.isArray(computers)) {
          let flagIndex = -1;
          computers.forEach((it, ind) => {
            if (it.ip == tempNode.attrs.name) {
              flagIndex = ind;
            }
          });
          if (flagIndex != -1) {
            computers.splice(flagIndex, 1);
          }
          this.$set(this, "computers", computers);
        }
      } catch (error) {
        console.log(error);
      }
      try {
        let form = JSON.parse(JSON.stringify(this.form));
        if (form.extra && Array.isArray(form.extra)) {
          let flagIndex = -1;
          form.extra.forEach((it, ind) => {
            if (
              it.hasOwnProperty("uuidName") &&
              it.uuidName == tempNode.attrs.uuidName
            ) {
              flagIndex = ind;
            }
          });
          if (flagIndex != -1) {
            form.extra.splice(flagIndex, 1);
          }
          this.$set(this.form, "extra", form.extra);
        }
      } catch (error) {
        console.log(error);
      }

      $(".context-menu").css({
        display: "none",
      });
    },
    //
    coverImg: function (e) {
      let reader = new FileReader();
      let that = this;
      let fileObj = e.target.files[0];

      if (e.target.files.length == 0) {
        return false;
      }
      // 判断图片大小
      if (fileObj.size > this.coverImgMaxSize) {
        this.errorMsg = "上传图片的大小不能超过15MB";
        this.openErrorTip = true;
        this.$message({
          message: "上传图片的大小不能超过15MB",
          customClass: "error",
        });
        return false;
      }

      reader.onload = (function (file) {
        return function (e) {
          let that2 = this; // 缓存当前this
          let img = new Image();
          img.src = this.result;
          img.onload = function () {
            // 
            console.log("width",this.width);
            console.log("height",this.height);
            if(this.width!=1920 && this.height!=1080){
              that.$message({
                message: "请上传 1920x1080 像素的照片！",
                customClass: "error",
              });
              return false;
            }
            // 
            let imgBase64 = that2.result; //获得图片的base64的数据
            that.mobileUploadImg(imgBase64);
          };
          $(".pcImgFile").val("");
        };
      })(e.target.files[0]);
      reader.readAsDataURL(e.target.files[0]);
    },
    mobileUploadImg: function (imgBase64) {
      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$http
        .post(
          API_BASE_URL + "v1/image/json/upload?storeId=" + this.curStoreId,
          {
            file: imgBase64,
          }
        )
        .then((res) => {
          this.form.background = res.data.path;
          this.$message({ customClass: "success", message: "上传成功" });
          this.noData = false;
          this.$nextTick(() => {
            this.createStage(1999);
          });
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    },
    upImage: function (e) {
      $(".context-menu-extra").css({
        display: "none",
      });
      let reader = new FileReader();
      let that = this;
      let fileObj = e.target.files[0];

      if (e.target.files.length == 0) {
        return false;
      }

      // 判断图片大小
      if (fileObj.size > this.coverImgMaxSize) {
        this.errorMsg = "上传图片的大小不能超过15MB";
        this.openErrorTip = true;
        this.$message({
          message: "上传图片的大小不能超过15MB",
          customClass: "error",
        });
        return false;
      }

      reader.onload = (function (file) {
        return function (e) {
          let that2 = this; // 缓存当前this
          let img = new Image();
          img.src = this.result;
          img.onload = function () {
            let imgBase64 = that2.result; //获得图片的base64的数据
            that.doUpimg(imgBase64);
          };
          $(".upImage").val("");
        };
      })(e.target.files[0]);
      reader.readAsDataURL(e.target.files[0]);
    },
    doUpimg: function (imgBase64) {
      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$http
        .post(
          API_BASE_URL + "v1/image/json/upload?storeId=" + this.curStoreId,
          {
            file: imgBase64,
          }
        )
        .then((res) => {
          this.createExtra(
            "image",
            { ...this.imageObj, path: res.data.path },
            true
          );
          this.$message({ customClass: "success", message: "上传成功" });
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    },
    //
    doShowDrawer() {
      this.showDrawer = true;
      this.$nextTick(() => {
        console.log($(".site-img img"));
        $(".site-img img").each((ind, ite) => {
          $(ite).on("dragstart", (e) => {
            console.log($(e.target).data());
            const ipImgData = $(e.target).data();
            let flag = false;
            if (this.computerLayer) {
              this.computerLayer.getChildren((node) => {
                if (node.getClassName() == "Group") {
                  if (node.attrs.name == ipImgData.fillname) {
                    flag = true;
                  }
                }
              });
            }

            if (flag) {
              this.$set(this.computerObj, "ip", "");
              this.$message({ customClass: "error", message: "此机位已添加" });
              return;
            } else {
              this.$set(this.computerObj, "ip", ipImgData.ipaddress);
              this.$set(this.computerObj, "name", ipImgData.fillname);
              // this.$set(this.computerObj, "fillName", ipImgData.fillname);
              console.log("this.computerObj",this.computerObj)
            }
          });
        });
      });
    },
    computedIpNo(ip) {
      let tempIp = ip.trim();
      const ipArr = tempIp.split(".");
      return ipArr[ipArr.length - 1];
    },
    getSite() {
      this.$http({
        url: "region/list",
        method: "POST",
        data: {
          storeId: this.curStoreId,
        },
      }).then((res) => {
        this.sites = res.data;
        let siteNamesObj = {};
        if(res.data && Array.isArray(res.data)){
          res.data.forEach(it=>{
            if(it.nums && Array.isArray(it.nums)){
              it.nums.forEach(ite=>{
                siteNamesObj[ite.ipAddress] = ite.name;
              })
            }
          })
        }
        this.siteNamesObj = siteNamesObj;
      });
    },
    getScreenDetail() {
      this.$http({
        url: "map/detail",
        method: "GET",
        params: {
          storeId: this.curStoreId,
        },
      }).then((res) => {
        console.log(res);
        if (res.data) {
          this.noData = false;
          if (!res.data.h5JsonText) {
            this.noData = true;
          }
          try {
            if (res.data.h5JsonText) {
              let jsonText = JSON.parse(res.data.h5JsonText);
              if(jsonText.hasOwnProperty("computerFillColor")){
                this.form = jsonText;
              }else{
                this.form = jsonText;
                this.form.computerFillColor = "#e66a6a";
              }
              if(!jsonText.hasOwnProperty("computerTextColor")){
                this.form.computerTextColor = "#fff";
              }
              this.$forceUpdate();
              if (jsonText.hasOwnProperty("canvasJsonText")) {
                let obj = {};
                try {
                  jsonText.canvasJsonText.forEach((it) => {
                    obj[it.ip] = it;
                  });
                } catch (error) {}
                let tempComputers = [];
                for (let k in obj) {
                  tempComputers.push(obj[k]);
                }
                this.computers = tempComputers;
              }
              console.log(this.form);
              console.log(this.computers);
              setTimeout(() => {
                this.createStage();
              }, 100);
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          this.noData = true;
          try {
            // let jsonText = localStorage.getItem("jsonText");
            // if (jsonText) {
            //   jsonText = JSON.parse(jsonText);
            //   this.form = jsonText;
            //   if (jsonText.hasOwnProperty("canvasJsonText")) {
            //     this.computers = jsonText.canvasJsonText;
            //   }
            //   console.log(this.form);
            //   this.$nextTick(() => {
            //     this.createStage();
            //   });
            // }
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
  },
  mounted() {
    console.log(window.location);
    this.bigScreenUrl = `${window.location.origin}/#/sys/${this.curStoreId}/bigScreenFrontEnd`;
    this.bigScreenUrlForAd = `${window.location.origin}/#/sys/${this.curStoreId}/bigScreenFrontEndWithoutAutoScreen`;
    this.getSite();
    this.getScreenDetail();
  },
};
</script>
<style lang="scss" scoped>
.big-screen {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  overflow-x: auto;
  box-sizing: border-box;
  background-color: rgb(246, 247, 251);
  position: relative;
  .modify-wrap {
    height: 70px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    .txt-color{
      display: flex;
      align-items: center;
      font-size: 12px;
      padding-left: 10px;
    }
    .pcImgFile {
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      cursor: pointer;
    }
    .tip {
      width: 100%;
      text-align: center;
      color: red;
      font-weight: bold;
    }
  }
  .size {
    width: auto;
    margin-right: 20px;
    display: flex;
    align-items: center;
    .tit {
      font-size: 12px;
    }
  }
  .out-wrap {
    position: relative;
    width: 1920px;
    height: 1080px;
    min-width: 1920px;
    min-height: 1080px;
    margin: 0px auto;
    .canvas-wrap {
      width: 1920px;
      height: 1080px;
      /* width: 1920px; */
      /* height: 1080px; */
      min-width: 1920px;
      min-height: 1080px;
      background-color: #fff;
      margin: 0px auto;
      position: relative;
    }
    .nodata-tip {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 20px;
      font-weight: 300;
      color: #333;
      letter-spacing: 3px;
    }
  }

  .drawer-wrap {
    width: 450px;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    background-color: #fff;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 9;
    box-shadow: 0px 0px 19px 19px rgba(0, 0, 0, 0.1);
    .inner-wrap {
      padding: 10px 20px;
      box-sizing: border-box;
      font-size: 14px;
      .tit {
        display: flex;
        height: 30px;
        align-items: center;
        justify-content: space-between;
        .close {
          color: red;
          cursor: pointer;
          font-size: 14px;
        }
      }
    }
    .drawer-cont {
      user-select: none;
      .site-img {
        display: inline-block;
        width: 33%;
        height: 32px;
        padding: 10px;
        box-sizing: border-box;
        text-align: center;
        position: relative;
        img {
          width: 32px;
          height: 32px;
          cursor: pointer;
        }
        .ip-no {
          position: absolute;
          top: 18px;
          left: 50%;
          transform: translateX(-50%);
          color: #fff;
          font-size: 12px;
          line-height: 12px;
          cursor: pointer;
        }
      }
    }
  }
  .context-menu,
  .context-menu-extra {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 60px;
    min-height: 30px;
    text-align: center;
    background-color: #fff;
    z-index: 10;
    line-height: 30px;
    font-size: 12px;
    user-select: none;
    cursor: pointer;
    .del {
      display: inline-block;
      width: 100%;
      height: 30px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
      position: relative;
      .upImage {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        cursor: pointer;
      }
    }
  }
  .cont-item {
    .tip {
      font-size: 14px;
      padding: 10px 0;
      color: #333;
      font-weight: 400;
    }
  }
}
.my-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 5;
  .inner-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -80%);
    width: 20%;
    height: auto;
    background-color: #fff;
    padding: 30px 20px;
    border-radius: 10px;
    .btns{
      text-align: right;
    }
  }
}
</style>
<style lang="scss">
@import "../../../static/css/common.scss";
@import "../tableTemplate/tableTem.scss";
@import "../tableTemplate/el-dialog.scss";
.el-collapse-item {
  height: auto;
  min-height: 43px;
}
.upLoad {
  position: relative;
}
.el-collapse-item__header {
  height: auto;
  min-height: 43px;
}
.extra {
  width: 20% !important;
  .el-dialog__body {
    padding: 20px 30px;
  }
}
.el-color-picker{
  height: 36px;
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// index.vue?f452bc7e